var map = {
	"./CaterPillar.png": 26,
	"./Henkel.png": 27,
	"./Ikea.png": 28,
	"./John-Deere.png": 29,
	"./McDonalds.png": 30,
	"./Nike.png": 31,
	"./Reebok.png": 32,
	"./cursor.svg": 33,
	"./logo.svg": 6,
	"./profile-icon.svg": 34,
	"./profile-image.png": 7,
	"./search.svg": 35
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;